import { faChevronsRight } from '@fortawesome/pro-solid-svg-icons/faChevronsRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorMessage } from '@hookform/error-message';
import { Button, ColourStateSolid, ValidationError } from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';

export type RulesetScanTypeType = {
	name: string;
};

const ThingList = [
	{ label: 'Content', value: 0 },
	{ label: 'Envelope', value: 1 },
	{ label: 'All', value: 2 },
];

function RulesetScanType(props: RulesetScanTypeType) {
	const { control, getFieldState, getValues, formState } = useFormContext();

	return (
		<div className={`thing-action mb-sm ${getFieldState(props.name).invalid ? 'invalid' : ''}`}>
			<input type='text' readOnly defaultValue='Mailboxes Scans' />
			<div className='thing-icon'>
				<FontAwesomeIcon icon={faChevronsRight} className='hidden' />
			</div>
			<div className='thing-types'>
				<Controller
					control={control}
					name={props.name}
					defaultValue={getValues(props.name)}
					rules={{
						required: true,
						validate: (val) => (val === -1 ? 'Mailboxes Scan Type is required' : true),
					}}
					render={({ field }) => (
						<>
							{ThingList.map((thing, index) => (
								<Button
									key={`ruleScanType-${thing.label}`}
									title={thing.label}
									fullWidth
									squared
									onClick={() => field.onChange(index)}
									colour={
										getValues(props.name) === index
											? ColourStateSolid.Selected
											: ColourStateSolid.Secondary
									}
								/>
							))}
						</>
					)}
				/>
			</div>

			<ErrorMessage
				errors={formState.errors}
				name={props.name}
				render={({ message }) => <ValidationError value={message} />}
			/>
		</div>
	);
}

export { RulesetScanType };
